"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Array2DHashMap = void 0;

var Array2DHashSet_1 = require("./Array2DHashSet");

var MapKeyEqualityComparator = /*#__PURE__*/function () {
  function MapKeyEqualityComparator(keyComparator) {
    _classCallCheck(this, MapKeyEqualityComparator);

    this.keyComparator = keyComparator;
  }

  _createClass(MapKeyEqualityComparator, [{
    key: "hashCode",
    value: function hashCode(obj) {
      return this.keyComparator.hashCode(obj.key);
    }
  }, {
    key: "equals",
    value: function equals(a, b) {
      return this.keyComparator.equals(a.key, b.key);
    }
  }]);

  return MapKeyEqualityComparator;
}();

var Array2DHashMap = /*#__PURE__*/function () {
  function Array2DHashMap(keyComparer) {
    _classCallCheck(this, Array2DHashMap);

    if (keyComparer instanceof Array2DHashMap) {
      this.backingStore = new Array2DHashSet_1.Array2DHashSet(keyComparer.backingStore);
    } else {
      this.backingStore = new Array2DHashSet_1.Array2DHashSet(new MapKeyEqualityComparator(keyComparer));
    }
  }

  _createClass(Array2DHashMap, [{
    key: "clear",
    value: function clear() {
      this.backingStore.clear();
    }
  }, {
    key: "containsKey",
    value: function containsKey(key) {
      return this.backingStore.contains({
        key: key
      });
    }
  }, {
    key: "get",
    value: function get(key) {
      var bucket = this.backingStore.get({
        key: key
      });

      if (!bucket) {
        return undefined;
      }

      return bucket.value;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.backingStore.isEmpty;
    }
  }, {
    key: "put",
    value: function put(key, value) {
      var element = this.backingStore.get({
        key: key,
        value: value
      });
      var result;

      if (!element) {
        this.backingStore.add({
          key: key,
          value: value
        });
      } else {
        result = element.value;
        element.value = value;
      }

      return result;
    }
  }, {
    key: "putIfAbsent",
    value: function putIfAbsent(key, value) {
      var element = this.backingStore.get({
        key: key,
        value: value
      });
      var result;

      if (!element) {
        this.backingStore.add({
          key: key,
          value: value
        });
      } else {
        result = element.value;
      }

      return result;
    }
  }, {
    key: "size",
    get: function get() {
      return this.backingStore.size;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return this.backingStore.hashCode();
    }
  }, {
    key: "equals",
    value: function equals(o) {
      if (!(o instanceof Array2DHashMap)) {
        return false;
      }

      return this.backingStore.equals(o.backingStore);
    }
  }]);

  return Array2DHashMap;
}();

exports.Array2DHashMap = Array2DHashMap;